import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from "pinia";
// import VScaleScreen from 'v-scale-screen'
import router from './router'
import ViewUIPlus from 'view-ui-plus'
import 'view-ui-plus/dist/styles/viewuiplus.css'
import './style/base.css'
import './style/common.scss'
// import './utils/flexible'
// import './utils/rem'



createApp(App).use(createPinia()).use(ViewUIPlus).use(router).mount('#app')
